import React from "react";
import "tw-elements";

const SupportAdCard = () => {
  return (
    <div className="hidden relative container mx-auto h-40 grad-sec text-center">
      Play & Support Compaigns
      <button className="absolute right-2 top-2 rounded-full px-[6px] border border-primary text-primary">
        X
      </button>
    </div>
  );
};

export default SupportAdCard;
